import React, { useState, useCallback } from 'react';
import './App.css';
import { useAuth } from './context/AuthContext';
import Login from './components/Login';
import Sidebar from './components/Sidebar';
import HistoryPanel from './components/HistoryPanel';
import TextToImage from './components/TextToImage';
import ImageToImage from './components/ImageToImage';
import TextToVideo from './components/TextToVideo';
import ImageToVideo from './components/ImageToVideo';
import RefToVideo from './components/RefToVideo';

const TABS = ['t2i', 'i2i', 't2v', 'i2v', 'r2v'];

function App() {
  const { token } = useAuth();
  const [activeTab, setActiveTab] = useState('t2v');
  const [showHistory, setShowHistory] = useState(false);
  const [history, setHistory] = useState([]);

  const addHistory = useCallback((entry) => {
    setHistory(prev => [{ ...entry, id: Date.now(), createdAt: new Date() }, ...prev].slice(0, 50));
  }, []);

  if (!token) {
    return <Login />;
  }

  return (
    <div className="app">
      <Sidebar
        activeTab={activeTab}
        onTabChange={setActiveTab}
        historyCount={history.length}
        onHistoryToggle={() => setShowHistory(v => !v)}
        showHistory={showHistory}
      />

      <div className="content">
        <div className="content-inner">
          {activeTab === 't2i' && <TextToImage onSave={addHistory} />}
          {activeTab === 'i2i' && <ImageToImage onSave={addHistory} />}
          {activeTab === 't2v' && <TextToVideo onSave={addHistory} />}
          {activeTab === 'i2v' && <ImageToVideo onSave={addHistory} />}
          {activeTab === 'r2v' && <RefToVideo onSave={addHistory} />}
        </div>
      </div>

      {showHistory && (
        <HistoryPanel
          history={history}
          onClose={() => setShowHistory(false)}
          onTabChange={(tab) => { setActiveTab(tab); setShowHistory(false); }}
        />
      )}
    </div>
  );
}

export default App;
